import React, { useEffect } from 'react';
import { TopBar } from './components/TopBar';
import { Hero } from './components/Hero';
import { WhatsIncluded } from './components/WhatsIncluded';
import { FoodGallery } from './components/FoodGallery';
import { Benefits } from './components/Benefits';
import { Testimonials } from './components/Testimonials';
import { Pricing } from './components/Pricing';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { FloatingWhatsApp } from './components/FloatingWhatsApp';
import { ImageCarousel } from './components/ImageCarousel';
export function App() {
  useEffect(() => {
    !function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    window.fbq('init', 'TU_PIXEL_ID');
    window.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-white font-sans text-gray-800 selection:bg-vibrantGreen selection:text-white" data-id="element-0">
      <TopBar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />

        {/* Carrusel 1 — Vistazo rápido tras el hero */}
        <ImageCarousel title="Un Vistazo a Tus Próximas Cenas" subtitle="Desliza para ver ejemplos visuales de lo que vas a preparar en menos de 15 minutos." slides={5} background="white" aspectRatio="video" data-id="element-4" />

        <WhatsIncluded data-id="element-5" />

        {/* Carrusel 2 — Galería extendida de recetas */}
        <ImageCarousel title="Recetas Destacadas" subtitle="Bowls, air fryer, meal prep, postres fitness y mucho más." slides={6} background="white" aspectRatio="wide" data-id="element-6" />

        <FoodGallery data-id="element-7" />
        <Benefits data-id="element-8" />

        {/* Carrusel 3 — Antes y después / resultados */}
        <ImageCarousel title="Resultados Reales" subtitle="Antes y después de quienes ya están aplicando el recetario." slides={4} background="lightGreen" aspectRatio="square" data-id="element-9" />

        <Testimonials data-id="element-10" />
        <Pricing data-id="element-11" />
        <FAQ data-id="element-12" />
        <FinalCTA data-id="element-13" />
      </main>
      <Footer data-id="element-14" />
      <FloatingWhatsApp data-id="element-15" />
    </div>;
}